import CoconeuseBioTemplate from "../../components/coconeuses/CoconeuseBioTemplate";

const CoconeuseStephanieValouse = () => (
  <CoconeuseBioTemplate
    name="Stéphanie"
    subtitle="Kinésithérapeute · Ostéopathe · Chi Nei Tsang"
    mainPhoto="https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/v301k76m_WhatsApp%20Image%202026-02-08%20at%2017.22.12.jpeg"
    photoPosition="center 65%"
    bioText={[
      "Bonjour, je suis Stéphanie.",
      "Depuis toujours, mes mains écoutent, ressentent et relient.",
      "Kinésithérapeute, ostéopathe, praticienne en Chi Nei Tsang et en micronutrition, j'accompagne chaque être vers un mieux-être global, respectueux du rythme du corps et de sa mémoire.",
      "J'aime ce chemin du soin qui relie le physique, l'émotionnel, l'énergétique et l'alimentaire… et j'honore la douceur comme véritable voie de transformation.",
    ]}
    bioPdf="https://customer-assets.emergentagent.com/job_d1425ff6-fbcb-4880-b341-80ef8fe0aeaa/artifacts/6gtwho63_Bio%20Ste%CC%81phanie%202026.pdf"
    galleryPhotos={[
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/gx7uxefi_WhatsApp%20Image%202026-02-08%20at%2017.22.13%20%281%29.jpeg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/11s76nrp_WhatsApp%20Image%202026-02-08%20at%2017.22.13.jpeg",
      "https://customer-assets.emergentagent.com/job_6603108a-de24-4f36-aea5-adcbc13cbf2a/artifacts/n3cjvc34_WhatsApp%20Image%202026-02-08%20at%2017.22.21.jpeg",
    ]}
    expertise={["Ostéopathie", "Chi Nei Tsang", "Intelligence du corps"]}
    backPath="/coconeuses#profil-stephanie"
    backLabel="Retour aux Coconeuses"
  />
);

export default CoconeuseStephanieValouse;
